import $ from 'jquery'

import { ScheduleHelp } from './schedule-help'
import { ScheduleModel } from './schedule-model'
import { ScheduleValidation } from './schedule-validation'

class ScheduleModal {
  constructor() {
    this.help = new ScheduleHelp()
    this.model = new ScheduleModel()
    this.validation = new ScheduleValidation()
  }

  /**
   * Register the handler for input changes.
   */
  listenToChange() {
    const target = 'input.schedule-time'
    $('#ID_SCHEDULE_MODAL').on('change', target, this.onChange.bind(this))
  }

  /**
   * Register the handler for the change notification type event.
   */
  listenToChangeType() {
    $('#schedule-notification-type').on('change', this.onChangeType.bind(this))
    $('#schedule-type-all').on('change', this.onChangeType.bind(this))
  }

  /**
   * Register the handler for the click the reset button event.
   */
  listenToClear() {
    $('#schedule-clear').on('click', this.onClear.bind(this))
  }

  /**
   * Register the handler for the modal opening event.
   */
  listenToOpen() {
    $('#ID_BTN_SCHEDULE').on('click', this.onOpen.bind(this))
  }

  /**
   * Register the handler for the click the save button event.
   */
  listenToSave() {
    $('#ID_SCHEDULE_MODAL_SAVE').on('click', this.onSave.bind(this))
  }

  /**
   * Register the handler for the click the add range button event.
   */
  listenToAddRange() {
    $('#schedule-add-interval').on('click', this.onAddRange.bind(this))
  }

  /**
   * Register the handler for the click the remove range button event.
   */
  listenToRemoveRange() {
    const target = '.schedule-time-range .schedule-delete'
    $('#ID_SCHEDULE_MODAL').on('click', target, this.onRemoveRange.bind(this))
  }

  /**
   * Register the handler for the click the reset button event.
   */
  listenToReset() {
    $('#schedule-reset').on('click', this.onReset.bind(this))
  }

  /**
   * Initialize the module.
   */
  onLoad() {
    this.listenToOpen()
    this.listenToSave()

    this.listenToChange()
    this.listenToChangeType()

    this.listenToAddRange()
    this.listenToRemoveRange()

    // this.listenToClear()
    this.listenToReset()

    this.help.onLoad()
  }

  /**
   * Handle the modal opening event.
   */
  onOpen() {
    this.clearErrors()
    window.CfgManager.rememberSelectedRows()
    const config = window.CfgManager.getSelectedTagConfig()
    const notifications = config.hasOwnProperty('notifications') ?
      config.notifications : []
    $('#schedule-type-all').prop('checked', false)
    $('#schedule-notification-type').show()
    $('#schedule-notification-type').val('batt')
    this.model.load(notifications)
    this.onChangeType()
  }

  /**
   * Handle the click the save button event.
   */
  onSave(event) {
    $('#ID_SCHEDULE_MODAL_SAVE').prop('disabled', true)
    this.clearErrors()
    this.model.pull()
    const invalids = this.validation.validateForm(this.model)
    if ( ! this.validation.valid) {
      this.showErrors(invalids)
    }
    else {
      this.updateConfig()
    }
  }

  /**
   * Handle input change events.
   */
  onChange(event) {
    this.model.pull()
    this.validation.validateForm(this.model, true)
    this.updateSaveButton()
    this.clearErrors()
    this.highlightInvalids(this.validation.invalids)
  }

  /**
   * Handle input change notification type events.
   */
  onChangeType(event) {
    let type = null
    if ($('#schedule-type-all').is(':checked')) {
      type = 'all'
      $('#schedule-notification-type').hide()
      $('#schedule-notification-type-all').show()
    }
    else {
      type = $('#schedule-notification-type').val()
      $('#schedule-notification-type').show()
      $('#schedule-notification-type-all').hide()
    }
    this.model.changeType(type)
    this.onChange(event)
  }

  /**
   * Handle the click the add range button event.
   */
  onAddRange(event) {
    this.model.addInterval()
    // this.onChange(event)
  }

  /**
   * Handle the click the delete range button event.
   */
  onRemoveRange(event) {
    let index
    let $target = $(event.target)
    do {
      index = $target.data('schedule-index')
      $target = $target.parent()
    }
    while (index === undefined && $target.length > 0)

    this.model.removeInterval(index)
    this.onChange(event)
  }

  /**
   * Handle the click the clear button event by removing the schedule.
   */
  onClear(event) {
    this.model.clear()
    this.onChange(event)
  }

  /**
   * Handle the click the reset button event by undoing all changes.
   */
  onReset(event) {
    this.model.reset()
    this.onChange(event)
  }

  /**
   * POST the configuration to the API.
   */
  updateConfig() {
    const settings = this.model.notificationSettings
    window.CfgManager.notificationSettings = settings
    window.CfgManager.updateConfig('set_schedule')
  }

  /**
   * Enable or disable the save button depending on the validity of the form.
   */
  updateSaveButton() {
    const canSave = this.validation.canSave()
    $('#ID_SCHEDULE_MODAL_SAVE').prop('disabled', ! canSave)
  }

  /**
   * Remove classes with error styles from all interval boxes.
   */
  clearHighlights() {
    for (let i = 0; i < this.model.intervals.length; i++) {
      const $range = $(`#schedule-range-${i}`)
      $range.removeClass('required')
    }
  }

  /**
   * Add classes with error styles to the interval box.
   */
  highlightInvalids(invalids) {
    for (const index of invalids) {
      const $range = $(`#schedule-range-${index}`)
      $range.addClass('required')
    }
  }

  /**
   * Remove any error messages displayed on the form.
   */
  clearErrors() {
    const $errors = $('#ID_SCHEDULE_MODAL .error-messages')
    $errors.slideUp('slow')
    $errors.html('')
    this.clearHighlights()
  }

  /**
   * Display the error messages on the form.
   */
  showErrors(invalids) {
    const $errors = $('#ID_SCHEDULE_MODAL .error-messages')
    let errorsHtml = ''
    for (const id in this.validation.errors) {
      const errorMessage = this.validation.errors[id]
      errorsHtml += `<div class="alert alert-danger" role="alert">${errorMessage}</div>`
    }
    $errors.html(errorsHtml)
    $errors.slideDown('slow')
    this.highlightInvalids(invalids)
  }
}

export { ScheduleModal }
